import { UseCustomAxios } from "../../UseCustomAxios";
import { useRecoilState } from "recoil";
import { rsActiveMenu } from "../../RecoilStates";

export function UseMenu() {
  const MyAxios = UseCustomAxios();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);

  const getMenu = (callback) => {
    MyAxios.get(`Admin_menus`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
        setCurrentMenu(response.data.resault);
      }
    });
  };

  function setCurrentMenu(pages) {
    let isCHild = window.location.pathname.substring(
      window.location.pathname.indexOf("/") + 1,
      window.location.pathname.lastIndexOf("/")
    );
    const pathname = window.location.pathname;
    const pathnameParts = pathname.split("/").filter(Boolean);
    const expectedResults = pathnameParts.slice(0);
    let path =
      isCHild == "/"
        ? window.location.pathname.substring(1)
        : expectedResults[0];

    var allMenu = [];
    pages.map((gp) => {
      allMenu.push.apply(allMenu, gp.pages);
    });
    if (path == "") {
      setMsActiveMenu(allMenu[0]);
      return;
    }
    allMenu.map((menu) => {
      if (menu.pageAddress == path) {
        setMsActiveMenu(menu);
      }
    });
  }

  return {
    getMenu,
    setCurrentMenu,
  };
}
